import { atom } from "jotai";

export const startingStackAtom = atom(0);
export const avgCostPerBTCPriceAtom = atom(0);
export const isSatoshis = atom(true);
